<template>
    <div class="field is-expanded">
        <model-select :options="options"
                      v-model="user"
                      class="input"
                      placeholder="Select Client">
        </model-select>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import apiUsers from './../../../../api/apiUsers'
export default {
  components: {
          ModelSelect
  },
  data () {
      return {
          options: []
      }
  },
  computed: {
      user: {
          get() {
              return this.$store.getters.getCustomInvoice.user_id
          },
          set(value) {
              this.$store.dispatch('fetchCustomInvoiceContactDetails', value)
              this.$store.dispatch('changeCustomInvoiceFieldValue', {field: 'user_id', value: value })
          }
      }
  },
  methods: {
      setSelectOptions (users) {
          let list = []

           users.forEach(function(element) {
               list.push({
                   value: element.id,
                   text: element.name
               })
           })

          this.options = list
      }
  },
  created() {
      apiUsers
          .requestAllUsers()
          .then((response) => {
                  this.setSelectOptions(response.data)
          })
          .catch((error) => {
                  console.log(error)
          })
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Invoices/CustomInvoice/CustomInvoiceClientSelect.vue